export const ELECTION_STATUS_NAME_MAP = {
  close_main_roll: 'Close Main Roll',
  nominations_open: 'Call for Nominations',
  nominations_close: 'Nominations Close',
  voting_open: 'Voting Papers Issued',
  voting_close: 'Election Day',
  results_released: 'Count Votes',
}

export const GOOGLE_TRANSLATE_WIDGET_LANGUAGES = [
  { key: 'English', value: 'en' },
  { key: 'Chinese (Simplified)', value: 'zh-CN', hideCountdown: true },
  { key: 'Maori', value: 'mi' },
  { key: 'Samoan', value: 'sm' },
]
